import { ChangeDetectorRef, Component, HostBinding, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-custom-socket',
  template: ``,
  styleUrls: ['./custom-socket.component.scss'],
})
export class CustomSocketComponent implements OnChanges {
  @Input()
  public data!: any;

  @Input()
  public rendered!: () => void;

  @HostBinding('title')
  get title() {
    return this.data.name;
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.cdr.detach();
  }

  public ngOnChanges(): void {
    this.cdr.detectChanges();

    requestAnimationFrame(() => {
      return this.rendered();
    });
  }
}
